import { render, staticRenderFns } from "./Semaforo-mod.vue?vue&type=template&id=c6362b02"
import script from "./Semaforo-mod.vue?vue&type=script&lang=js"
export * from "./Semaforo-mod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports